import { render, staticRenderFns } from "./GoogleSheetIntroduction.vue?vue&type=template&id=01a2bb28&scoped=true"
import script from "./GoogleSheetIntroduction.vue?vue&type=script&lang=ts"
export * from "./GoogleSheetIntroduction.vue?vue&type=script&lang=ts"
import style0 from "./GoogleSheetIntroduction.vue?vue&type=style&index=0&id=01a2bb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2bb28",
  null
  
)

export default component.exports